/** True when the browser tab likely has an in-app previous history entry. */
export function canBrowserHistoryBack(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  const navId = window.history.state?.navigationId;
  if (typeof navId === 'number') {
    return navId > 1;
  }
  return window.history.length > 1;
}
